import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/** 주소 기반 오버레이를 여닫는다. 열 때 history 에 쌓으므로 뒤로 가기로 닫힌다. */
export function useUrlOverlay(key: string) {
  const [searchParams, setSearchParams] = useSearchParams();

  const open = useCallback(
    (value: string | number) => {
      setSearchParams((previous) => {
        const next = new URLSearchParams(previous);
        next.set(key, String(value));
        return next;
      });
    },
    [key, setSearchParams],
  );

  const close = useCallback(() => {
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);
      next.delete(key);
      return next;
    });
  }, [key, setSearchParams]);

  return { value: searchParams.get(key), isOpen: searchParams.has(key), open, close };
}
